import type { AreaId } from './areaContract';

export type LensNavEvent =
  | { name: 'rail_click'; target: string }
  | { name: 'area_view'; areaId: AreaId }
  | { name: 'area_metric_drill'; areaId: AreaId; metricId: string }
  | { name: 'area_ask'; areaId: AreaId; suggested: boolean }
  | { name: 'area_certified_open'; areaId: AreaId; lensId: string }
  | { name: 'area_team_report_open'; areaId: AreaId; lensId: string }
  | { name: 'area_tableau_open'; areaId: AreaId; workbook: string }
  | { name: 'home_pulse_metric_open'; areaId: AreaId; metricId: string }
  | { name: 'home_executive_open'; title: string };

const DEBUG_KEY = 'askrichard.debug-nav-telemetry';

/**
 * Placeholder sink. The admin app has no product analytics client yet (no RUM, no Snowplow), so events
 * go nowhere unless the debug key is set in localStorage. Swap the body for the real sink; callers stay.
 */
export function trackLensNav(event: LensNavEvent): void {
  try {
    if (window.localStorage.getItem(DEBUG_KEY) === '1') {
      console.warn('[lens-nav]', event);
    }
  } catch {
    // Storage can be blocked; telemetry must never break navigation.
  }
}
